'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// /data/websites/bestcompany1982.it/httpdocs/wp-content/themes/g2k-theme-2/node_modules/core-js/internals/engine-user-agent.js
// module id = 125
// module chunks = 0